module.exports = __webpack_public_path__ + "static/media/twitter.350fb7df.svg";